import React from "react";
import { ReactComponent as OutlineCheckCircleFilled16 } from "assets/svg/outline-check-circle-filled-16.svg";
import messages from "messages";
import styles from "./styles.module.scss";

const OrchidVerifiedTag = () => {
  return (
    <div className={styles["orchid-verified-tag"]}>
      <OutlineCheckCircleFilled16
        className={styles["orchid-verified-tag__icon"]}
      />
      {messages.orchidVerified}
    </div>
  );
};

export default OrchidVerifiedTag;
